import { useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import "./style.css";
import styled from "@emotion/styled";
import { COLORS } from "../../../../Theme";
import CloseIcon from "@mui/icons-material/Close";

export default function FilterSelectV2({
  label = "",
  value,
  options,
  onSelect,
  bgColor,
  itemKey,
  showClear = false,
  width="210px",
  height="35px",
  style,
  disabled=false,
  boxStyle={},
  giveFullObject=false
}: {
  label: string;
  value?: string;
  options: any[];
  onSelect: (arg: any) => void;
  bgColor?: string;
  itemKey?: string;
  showClear?: boolean;
  width?: string | number;
  height?: string | number;
  style?: any;
  disabled?: boolean;
  boxStyle?: any;
  giveFullObject?: boolean;
}) {
  const [selectedValue, setSelectedValue] = useState(value);
  const handleChange = (event: SelectChangeEvent) => {
    const foundOption = options.find((opt) => {
      return itemKey ? opt[itemKey] === event.target.value : opt?.value === event.target.value
    })
    setSelectedValue(event.target.value as string);
    onSelect(giveFullObject ? foundOption : event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120, position: "relative", ...boxStyle }}>
      <FormControl sx={{ position: "relative" }}>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          disabled={disabled}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedValue}
          label={label}
          onChange={(e) => {
            console.log("e", e)
            handleChange(e)
          }
          }
          sx={{
            padding: "5px",
            backgroundColor: bgColor || COLORS.LIGHT_GRAY,
            width: width,
            height: height,
            fontFamily: "Lato, sans-serif",
            ...style,
          }}
        >
          {options.map((option: any) => {
            return (
              <MenuItem
                value={itemKey ? option[itemKey] : option.key}
                key={itemKey ? option[itemKey] : option.key}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </Select>
      {showClear && value && (
        <CloseIcon
          onClick={() => onSelect("")}
          sx={{
            position: "absolute",
            right: "35px",
            top: "7px",
            cursor: "pointer",
            color: COLORS.GRAY,
          }}
        />
      )}
      </FormControl>
    </Box>
  );
}

